import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, Injector, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModuleOptimized } from './shared-module-optimized/shared-module-optimized.module';
import { AuthRoutingModule } from './auth-routing.module';
import { LoaderComponent } from './common/loader/loader.component';
import { APIFactoryEndPoints } from './common/apifactory-end-points';
import { LoaderService } from './common/loader.service';
import { AuthInterceptor } from './shared/okta/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './common/loader-interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule, DecimalPipe, HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';

import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ChooseLocationDialogComponent } from './common/choose-location-dialog/choose-location-dialog.component';
import { Constant } from './common/constant';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { APP_BASE_HREF, AsyncPipe, DatePipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import moment from 'moment';

import { FacilitymanagerSetupService } from './service/Setup/facilitymanager-setup.service';
import { PermissionComponent } from './Module/Security/Dialog/permission/permission.component';
import { GatePassComponent } from './Module/Security/Dialog/gate-pass/gate-pass.component';
import { AppointmentComponent } from './Module/Security/Dialog/appointment/appointment.component';
import { VisitorPreviewComponent } from './Module/Common/PreviewTemplate/visitor-preview/visitor-preview.component';
import { MatGridListModule } from '@angular/material/grid-list';

import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DownloadPreviewComponent } from './Module/Common/PreviewTemplate/download-preview/download-preview.component';

import { MultipleTransactionComponent } from './Module/Common/Dialog/multiple-transaction/multiple-transaction.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { SelectPreferenceComponent } from './common/select-preference-dialog/select-preference/select-preference.component';
import { CreateOrderCustomerComponent } from './Module/Common/Dialog/create-order-customer/create-order-customer.component';
import { environment } from 'src/environments/environment';
import { MessagingService } from 'src/app/service/MessageService/messaging.service';

import { ProductDetailForCreateOrderComponent } from './Module/Order/Dialog/product-detail-for-create-order/product-detail-for-create-order.component';
import { RouteExportDialogComponentComponent } from './Module/Admin/Master/route/ExportDialog/route-export-dialog-component/route-export-dialog-component.component';
import { PreviewForPurchaseInvoiceComponent } from './Module/Purchase/PurchaseInvoice/PreviewForPurchaseInvoice/preview-for-purchase-invoice/preview-for-purchase-invoice.component';
import { EWayBillComponent } from './Module/Common/Dialog/eway-bill/eway-bill.component';
import { MatSliderModule } from '@angular/material/slider';
import { PreviewComponent } from './Module/Common/PreviewTemplate/Preview/preview/preview.component';
import { PurchasePaymentComponent } from './Module/Common/Dialog/purchase-payment/purchase-payment.component';
import { ConfirmationDialogComponent } from './common/ConfirmationDialog/confirmation-dialog/confirmation-dialog.component';
import { CreateNotificationComponent } from './Module/MessageCenter/Messaging/notification/create-notification/create-notification.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { GoogleChartsModule } from 'angular-google-charts';
import { CustomerDeliveryDetailsComponent } from './Module/Common/Dialog/customer-delivery-details/customer-delivery-details.component';
import { InvoiceNoDialogComponent } from './common/InvoiceNumberDialog/invoice-no-dialog/invoice-no-dialog.component';
import { BatchDialogComponent } from './Module/Common/Dialog/batch-dialog/batch-dialog.component';

import { AbsolutePipe } from './common/Pipe/absolute.pipe';
import { NotAuthorizedComponent } from './common/not-authorized/not-authorized.component';
import { PathOneResolver } from './common/PathOneResolver';
import { MobileNumberVerificationDialogComponent } from './Module/Common/Dialog/mobile-number-verification-dialog/mobile-number-verification-dialog.component';
import { SummaryWithDetailsDialogComponent } from './common/SummaryWithDetailsDialog/summary-with-details-dialog/summary-with-details-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { GoogleMapsModule } from '@angular/google-maps';

import { AssetPrintLabelDialogComponent } from './Module/Admin/Master/assets/AssetPrintLabel/asset-print-label-dialog/asset-print-label-dialog.component';
import { AssetQrCodeDialogComponent } from './Module/Admin/Master/assets/AssetQrCode/asset-qr-code-dialog/asset-qr-code-dialog.component';
import { PaytmComponent } from './common/paytm/paytm.component';
// import { initializeApp } from "firebase/app";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
// initializeApp(environment.firebase);

import { ConstantForOpenDiaog } from './common/ConstantForDialog/constant-for-open-diaog';
import { HRDashboardComponent } from './Module/HR1/hrdashboard/hrdashboard.component';
import { LoginComponent } from './common/login/login/login.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DigitalClockComponent } from './common/digitalClock/digital-clock/digital-clock.component';
import { GenerateQrDialogComponent } from './Module/Admin/Master/product/generate-qr-dialog/generate-qr-dialog.component';
import { ActionDialogComponent } from './Module/StoreOperation/action-dialog/action-dialog.component';
import { OktaLoginComponent } from './okta-login/okta-login.component';
import { PageNotFoundComponent } from './common/page-not-found/page-not-found.component';
import { QuantityDialogComponent } from './common/quantity-dialog/quantity-dialog.component';
import { ImagePopupComponent } from './common/image-popup/image-popup.component';
import { MultiplePaymentComponent } from './Module/Account/Dialog/multiple-payment/multiple-payment.component';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { AccountCostingAndBudgetingModule } from './ModuleAndRouting/Account/account-costing-and-budgeting/account-costing-and-budgeting.module';
import { Router } from '@angular/router';
import { RiderDetailsPreviewComponent } from './Module/Common/PreviewTemplate/rider-details-preview/rider-details-preview.component';
import { RiderDetailsSelfiePreviewComponent } from './Module/Common/PreviewTemplate/rider-details-selfie-preview/rider-details-selfie-preview.component';

import { FlightsModuleMobitrixWeb } from './flights/flights.module';
//import { ConfirmationWithReasonDialogComponent } from './common/ConfirmationWithReasonDialog/confirmation-with-reason-dialog/confirmation-with-reason-dialog.component';
import { RiderLocationDialogComponent } from './Module/Common/Dialog/rider-location-dialog/rider-location-dialog.component';
import { ImagePreviewDialogComponent } from './common/image-preview-dialog/image-preview-dialog.component';
import { ConfirmationDialogForBackupAndRestoreComponent } from './common/confirmation-dialog-for-backup-and-restore/confirmation-dialog-for-backup-and-restore.component';
import { GenerateSeoDialogComponent } from './Module/Admin/TransactionSetup/generate-seo-dialog/generate-seo-dialog.component';
import { EnterOtpDialogComponent } from './Module/Common/Dialog/enter-otp-dialog/enter-otp-dialog.component';
import { CustomizedOrdersPreviewComponent } from './Module/Common/customized-orders-preview/customized-orders-preview.component';
import { WhatsappDialogComponent } from './Module/Common/Dialog/whatsapp-dialog/whatsapp-dialog.component';
import { MonitoringDashboardComponent } from './monitoring-dashboard/monitoring-dashboard.component';
import { FileDialogViewComponent } from './common/file-dialog-view/file-dialog-view.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { DOCUMENT } from '@angular/common';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ConfirmationWithStatusAndReasonDialogComponent } from './common/confirmation-with-status-and-reason-dialog/confirmation-with-status-and-reason-dialog.component';
import { ConfirmationWithSpinnerDialogComponent } from './common/confirmation-with-spinner-dialog/confirmation-with-spinner-dialog.component';
import { B2bApprovalDialogComponentComponent } from './Module/StoreOperation/WholesaleCustomer/b2b-approval-dialog-component/b2b-approval-dialog-component/b2b-approval-dialog-component.component';
import { B2bRejectedDialogComponentComponent } from './Module/StoreOperation/WholesaleCustomer/b2b-rejected-dialog-component/b2b-rejected-dialog-component/b2b-rejected-dialog-component.component';
import { StatusDialogComponent } from './common/status-dialog/status-dialog.component';
import { UserChangePasswordComponent } from './Module/Admin/ManageUser/user-change-password/user-change-password.component';
import { EditConfirmationDialogComponent } from './Module/Order/WebOrder/edit-confirmation-dialog/edit-confirmation-dialog.component';
import { FranchaisEnquiryComponent } from './Module/CRM/Digiboard/franchais-enquiry/franchais-enquiry.component';
import { SpinAndWinProductsComponent } from './Module/Order/Dialog/spin-and-win-products/spin-and-win-products.component';
import { EnrollmentMasterDataComponent } from './Module/HR/Enrollment/enrollment-master-data/enrollment-master-data.component';
import { Form16Component } from './Module/HR/Payroll/form16/form16.component';
import { SignatorySetupComponent } from './Module/HR/PolicySetUp/signatory-setup/signatory-setup.component';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { MatBadgeModule } from '@angular/material/badge';
import { NgxMatTimepickerModule } from '@alexfriesen/ngx-mat-timepicker';
import { IdleWarningDialogComponent } from "./common/idle-dialog/IdleWarningDialog";
import { HrExpensesComponent } from './Module/Account/Expenses/hr-expenses/hr-expenses.component';
import { RejectReasonDialogComponent } from './common/reject-reason-dialog/reject-reason-dialog.component';
import { CumulativeSalaryComponent } from './Module/Account/Expenses/cumulative-salary/cumulative-salary.component';
import { AppConfigService } from "./service/Configuration/app-config.service";
import { ConfirmationWithReasonDialogComponent } from "./common/ConfirmationWithReasonDialog/confirmation-with-reason-dialog.component";
import { KeyboardShortcutDirective } from "./common/KeyBoardDirective";
import { HighchartsChartModule } from 'highcharts-angular';
import { OverlayModule } from '@angular/cdk/overlay';
import { ImagePdfViewComponent } from "./common/image-pdf-view/image-pdf-view.component";
import { ReceiptVoucherPreviewComponent } from "./Module/Common/PreviewTemplate/receipt-voucher-preview/receipt-voucher-preview.component";
import { SharedModule } from "./shared/shared/shared.module";
import { ConfirmationWithMailDialogComponent } from "./common/ConfirmationDialog/confirmation-with-mail-dialog/confirmation-with-mail-dialog.component";
import { CommonExternalModule } from "./ModuleAndRouting/Common/common-external/common-external.module";
import { KotPreviewComponent } from "./Module/Common/PreviewTemplate/kot-preview/kot-preview.component";
import { SubscriptionBannerComponent } from "./Module/ActiveSubscription/subscription-banner/subscription-banner.component";
import { SubscriptionExpiredComponent } from "./Module/ActiveSubscription/subscription-expired/subscription-expired.component";
import { UserLimitWarningComponent } from "./Module/ActiveSubscription/user-limit-warning/user-limit-warning.component";
// const oktaConfig = {
//   issuer: environment.issuer,
//   redirectUri: environment.redirectUri,
//   clientId: environment.clientId,
// };
export function initializeAppConfiguration(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();
}
@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    ChooseLocationDialogComponent,
    IdleWarningDialogComponent,
    LoginComponent,
    OktaLoginComponent,
    MultipleTransactionComponent,
    PurchasePaymentComponent,
    MultiplePaymentComponent,
    ConfirmationWithReasonDialogComponent,
    //ScanQRCodeDialogComponent,
    DownloadPreviewComponent,
    PreviewComponent,
    CreateOrderCustomerComponent,
    CustomerDeliveryDetailsComponent,
    MobileNumberVerificationDialogComponent,
    NotAuthorizedComponent,
    PageNotFoundComponent,
    QuantityDialogComponent,
    ImagePopupComponent,
    ProductDetailForCreateOrderComponent,
    ConfirmationDialogComponent,
    ConfirmationWithMailDialogComponent,
    SelectPreferenceComponent,
    RouteExportDialogComponentComponent,
    PreviewForPurchaseInvoiceComponent,
    BatchDialogComponent,
    InvoiceNoDialogComponent,
    SummaryWithDetailsDialogComponent,
    AssetPrintLabelDialogComponent,
    AssetQrCodeDialogComponent,
    GenerateQrDialogComponent,
    DigitalClockComponent,
    ActionDialogComponent,
    EWayBillComponent,
    VisitorPreviewComponent,
    AbsolutePipe,
    DashboardComponent,
    PermissionComponent,
    GatePassComponent,
    AppointmentComponent,
    PaytmComponent,
    RiderDetailsPreviewComponent,
    RiderDetailsSelfiePreviewComponent,
    // ConfirmationWithReasonDialogComponent,
    RiderLocationDialogComponent,
    ImagePreviewDialogComponent,
    ConfirmationDialogForBackupAndRestoreComponent,
    GenerateSeoDialogComponent,
    EnterOtpDialogComponent,
    CustomizedOrdersPreviewComponent,
    WhatsappDialogComponent,
    MonitoringDashboardComponent,
    FileDialogViewComponent,
    ImagePdfViewComponent,
    ConfirmationWithStatusAndReasonDialogComponent,
    ConfirmationWithSpinnerDialogComponent,
    B2bApprovalDialogComponentComponent,
    B2bRejectedDialogComponentComponent,
    StatusDialogComponent,
    UserChangePasswordComponent,
    EditConfirmationDialogComponent,
    FranchaisEnquiryComponent,
    SpinAndWinProductsComponent,
    EnrollmentMasterDataComponent,
    Form16Component,
    SignatorySetupComponent,
    HrExpensesComponent,
    RejectReasonDialogComponent,
    CumulativeSalaryComponent,
    KeyboardShortcutDirective,
    ReceiptVoucherPreviewComponent, 
    KotPreviewComponent,
    SubscriptionBannerComponent,
    SubscriptionExpiredComponent,
    UserLimitWarningComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    AccountCostingAndBudgetingModule,
    PdfViewerModule,
    OverlayModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    MatSliderModule,
    MatBadgeModule,
    GoogleMapsModule,
    BrowserModule,
    SharedModuleOptimized,
    AppRoutingModule,
    AuthRoutingModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatFormFieldModule,
    MatCardModule,
    NgxMatTimepickerModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FlexLayoutModule,
    MatListModule,
    MatSlideToggleModule,
    CommonModule,
    MatTableModule,
    MatSelectModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    MatAutocompleteModule,
    GoogleChartsModule,
    MatGridListModule,
    MatRadioModule,
    LeafletModule,
    MatBottomSheetModule,
    DragDropModule,
    MatCheckboxModule,
    HighchartsChartModule,
    MatExpansionModule,
    FlightsModuleMobitrixWeb,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    SharedModule,
    CommonExternalModule
  ],

  providers: [
    APIFactoryEndPoints,
    Constant,
    ConstantForOpenDiaog,
    LoaderService,
    DatePipe,
    FacilitymanagerSetupService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'auto' } },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: APP_INITIALIZER, useFactory: initializeAppConfiguration, deps: [AppConfigService], multi: true },
    MessagingService,
    AsyncPipe,
    PathOneResolver,
    DecimalPipe,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
  constructor() {
    Date.prototype.toJSON = function () {
      return moment(this).format("YYYY-MM-DDTHH:mm:ss");
    }
  }
}
